export const APP_FILE_RECONCILIATION_AGENCY_BILL = "/reconciliation/agency-bill";
export const APP_FILE_RECONCILIATION_DIRECT_BILL = "/reconciliation/direct-bill";
export const APP_FILE_RECONCILIATION_CUSTOMER_PAYABLE = "/reconciliation/customer-payable";